import { useState, useRef, useEffect, createElement, Fragment } from 'react';
import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { addClassNameToChildren } from '../util/react.js';
import { ensureComponentPainted } from '../util/animation.js';
import styles from '../styles/Fade.module.scss';

var Fade = function (_a) {
    var animateOnMount = _a.animateOnMount, children = _a.children, _b = _a.duration, duration = _b === void 0 ? 300 : _b, isVisible = _a.isVisible;
    var _c = useState(animateOnMount
        ? isVisible
            ? "invisible"
            : "visible"
        : isVisible
            ? "visible"
            : "invisible"), visibility = _c[0], setVisibility = _c[1];
    var isFirstRenderRef = useRef(true);
    useEffect(function () {
        if (!isFirstRenderRef.current || animateOnMount) {
            var isCanceled_1 = false;
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ensureComponentPainted()];
                        case 1:
                            _a.sent();
                            !isCanceled_1 && setVisibility(isVisible ? "visible" : "invisible");
                            return [2 /*return*/];
                    }
                });
            }); })();
            return function () {
                isCanceled_1 = true;
            };
        }
        isFirstRenderRef.current = false;
    }, [isVisible]);
    return (createElement(Fragment, null, addClassNameToChildren(children, styles[visibility], {
        transitionDuration: (typeof duration === "number"
            ? duration
            : duration[visibility === "visible" ? 0 : 1]) + "ms",
    })));
};

export default Fade;
